// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"148":"8fb589f8","531":"4e9c77b9","653":"7e98f591","766":"34a0a4eb"}[chunkId] + ".js";
};